import styles from '../assets/styles/cards.module.scss';

export default function RuntimeCard() {

  return (
    <section>
      <div id="runtimes" className={styles.cards}></div>
    </section>
  )
}